import React__default from 'react';
import { observe } from 'react-intersection-observer';

const useIntersectionObservers = (props) => {
    const { ids, options: optionsOutput, callback } = props;
    const options = React__default.useMemo(() => ({
        threshold: 1,
        ...optionsOutput,
    }), [optionsOutput]);
    const refs = React__default.useMemo(() => ids.reduce((acc, id) => {
        const ref = React__default.createRef();
        return {
            ...acc,
            [`${id}`]: ref,
        };
    }, {}), [ids]);
    React__default.useEffect(() => {
        const destroys = [];
        Object.values(refs).forEach((ref) => {
            if (!ref.current)
                return;
            const destroy = observe(ref.current, callback, options, false);
            destroys.push(destroy);
        });
        return () => {
            destroys.forEach((destroy) => destroy());
        };
    }, [refs, options, callback]);
    return {
        refs,
    };
};

export { useIntersectionObservers };
//# sourceMappingURL=useIntersectionObservers.js.map
